import React from 'react'
import AddStartpageComToYourHomeScreen from '../add-startpage-com-to-your-home-screen'

const AddStartpageComToYourHomeScreenFr = () => {
    return <AddStartpageComToYourHomeScreen languageCode="fr" />
}

export default AddStartpageComToYourHomeScreenFr
